import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { getMe } from '../services/api';

const CoinContext = createContext();

export const CoinProvider = ({ children }) => {
  const [coins, setCoins] = useState(0);
  const [isFlashing, setIsFlashing] = useState(false);

  const updateCoins = useCallback(async () => {
    try {
      const userData = await getMe();
      setCoins(prevCoins => {
        const newCoins = Number(userData.credits || 0);
        if (newCoins !== prevCoins) {
          setIsFlashing(true);
        }
        return newCoins;
      });
    } catch (error) {
      console.error('Failed to fetch coins:', error);
    }
  }, []);

  useEffect(() => {
    if (isFlashing) {
      const timer = setTimeout(() => {
        setIsFlashing(false);
      }, 1000); // Flash duration of 1 second
      return () => clearTimeout(timer);
    }
  }, [isFlashing]);

  const spendCoins = useCallback((amount) => {
    setCoins(current => {
      const newAmount = Number((current - amount).toFixed(2));
      setIsFlashing(true);
      return newAmount;
    });
  }, []);

  const formattedCoins = coins.toFixed(2);

  return (
    <CoinContext.Provider value={{ 
      coins: formattedCoins, 
      updateCoins, 
      spendCoins,
      isFlashing 
    }}>
      {children}
    </CoinContext.Provider>
  );
};

export const useCoins = () => {
  const context = useContext(CoinContext);
  if (!context) {
    throw new Error('useCoins must be used within a CoinProvider');
  }
  return context;
}; 